module.exports = "<div class=\"content-logo\">\r\n    <img class=\"responsive\" src=\"/background/logo.png\"/>\r\n</div>"